import ShoppingConsult from './containers/ShoppingConsult';

export default ShoppingConsult;
